module.exports = __webpack_public_path__ + "media/images/icons/time-outlined-36cc82f7a27cfd19a63ee68e19e25b6f.svg";